import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  shape: {
    borderRadius: 0,
  },
  palette: {
    primary: {
      main: '#131314',
    },
    secondary: {
      main: '#EB3D26',
    },
    success: {
      main: '#0FD347',
    },
    info: {
      main: '#3763FF',
    },
    divider: '#E0E0E0',
    text: {
      primary: '#131314',
      disabled: '#CCCCCC',
    },
  },
  typography: {
    fontFamily: 'IBMPlexSansRegular, Arial, serif',
    h1: {
      fontSize: 39,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: 25,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h2: {
      fontSize: 31,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: 20,
      fontWeight: 500,
      lineHeight: 1.3,
    },
    button: {
      fontFamily: 'IBMPlexSansRegular, Arial, serif',
      fontSize: 16,
      lineHeight: 1.3,
      fontWeight: 400,
      textTransform: 'none',
    },
    subtitle1: {
      fontSize: 14,
    },
    body1: {
      fontSize: 16,
    },
    caption: {
      fontSize: 12,
    },
  },
  overrides: {
    MuiButtonBase: {
      root: {
        padding: '8px 15px',
        fontFamily: 'IBMPlexSansMedium, Arial, serif',
      },
    },
    MuiInputBase: {
      root: {
        fontFamily: 'IBMPlexSansRegular, Arial, serif',
      },
    },
    MuiCheckbox: {
      root: {
        color: '#EB3D26',
      },
      colorSecondary: {
        '& Mui-disabled': {
          color: '#CCCCCC',
        },
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: '#CCCCCC',
      },
    },
    MuiTooltip: {
      popper: {
        height: '40px',
      },
      tooltip: {
        backgroundColor: '#F5F5F5',
        color: '#131314',
      },
      arrow: {
        color: '#F5F5F5',
      },
    },
  },
});
